import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as BetslipActions from 'actions/BetslipActions';
import * as TerminalBetslipActions from 'actions/TerminalBetslipActions';
import * as UiActions from 'actions/UiActions';
import { EVENT_STATUS, MARKET_STATUS } from 'constants/appConfig';
import { UI_ERROR_MESSAGE } from 'constants/ui';
import Button from 'ui/Button';
import { detectMobile, isTerminal } from 'utils/UiHelper';
import { OddsButtonWrapper, OddsText } from 'ui/OddsButtonWrapper';
import styled, { keyframes, css } from 'styled-components';
import { NotificationManager } from 'react-notifications';
import Text from '../ui/Text';
import { isActiveBetButton } from '../utils/UiHelper';
import { getErrorByCode } from '../utils/Helper';

const aze = keyframes`
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.5);
  }

  50% {
    transform: scale(0.5);
  }

  75% {
    transform: scale(1.3);
  }

  100% {
    transform: scale(1);
  }
`;

const plusCss = css`
    color: #00ff00;
`;
const minusCss = css`
    color: #ff0000;
`;
const OddsIndicator = styled.span`
    position: absolute;
    display: inline-block;
    z-index: 1;
    right: 5px;
    float: right;
    top: 33%;
    transform: translateY(-50%);
    animation: ${aze} 1000ms ease infinite;
    ${({ indicator }) =>
        indicator === 'plus'
            ? plusCss
            : indicator === 'minus'
                ? minusCss
                : null};
    @media screen and (max-width: 600px) {
        right: 3px;
    }
`;

class ViewOddsButton extends Component {
    static propTypes = {
        label: PropTypes.string,
        isOnlyOdds: PropTypes.bool,
        isCustomBet: PropTypes.bool,
        isFullWidthButtons: PropTypes.bool,
        shouldUpdateOdds: PropTypes.bool,
    };

    static defaultProps = {
        isOnlyOdds: false,
        favoriteEvent: null,
        eventObj: null,
        isCustomBet: false,
        isFullWidthButtons: false,
        shouldUpdateOdds: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            event: props.favoriteEvent || props.eventObj,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            !this.props.eventObj &&
            (this.props.favoriteEvent || nextProps.favoriteEvent)
        ) {
            if (
                nextProps.favoriteEvent &&
                nextProps.favoriteEvent !== this.state.event
            ) {
                this.setState({ event: nextProps.favoriteEvent });
            }
        }
        if (
            !this.props.favoriteEvent &&
            (this.props.eventObj || nextProps.eventObj)
        ) {
            if (nextProps.eventObj && nextProps.eventObj !== this.state.event) {
                this.setState({ event: nextProps.eventObj });
            }
        }
    }

    onClickHandler(e) {
        const market = this.props.market;
        const item = this.props.item;
        const isLive = this.props.isCustomBet
            ? this.state.event.data.live
                ? 1
                : 0
            : this.state.event.data.live
                ? '1'
                : '0';

        if (this.props.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (
            !isTerminal() &&
            !this.props.isCustomBet &&
            this.props.betslip.customBetEventId === null &&
            this.props.betslip.placedCustomBetMarkets.length === 0 &&
            !this.props.eventObj.isPendingUpdate
        ) {
            this.props.betslipActions.addMarket(
                market.marketId,
                item.betNr,
                item.odds,
                isLive,
                market.sportId,
                this.props.betslip.hasMarkets
            );
        } else if (this.props.betslip.placedCustomBetMarkets.length > 0) {
            this.props.uiActions.notification(
                UI_ERROR_MESSAGE,
                getErrorByCode('BAD_COMBINATION')
            );
        } else if (
            ((this.props.isCustomBet && !isTerminal()) ||
                this.props.betslip.customBetEventId !== null) &&
            this.props.betslip.placedCustomBetMarkets.length === 0
        ) {
            if (
                this.props.betslip.betList.length > 0 &&
                !this.props.betslip.isCustomBet
            ) {
                if (detectMobile()) {
                    let lsData = JSON.parse(
                        window.localStorage.getItem('clearRegularBetModalData')
                    );
                    if (lsData?.action === 'clearBetslip' && !lsData?.show) {
                        this.props.betslipActions.clearAllMarkets();
                        /*here need to pass empty array time to clearing hasMarkets is too long*/
                        setTimeout(() => {
                            this.props.betslipActions.addCustomBetMarket(
                                market.marketId,
                                item.betNr,
                                item.odds,
                                isLive,
                                [],
                                this.props.isCustomBet
                            );
                        }, 1000);
                    } else {
                        let betData = {
                            marketId: market.marketId,
                            betNr: item.betNr,
                            odds: item.odds,
                            isLive,
                            hasMarkets: this.props.betslip.hasMarkets,
                            isCustomBet: this.props.isCustomBet,
                        };
                        this.props.uiActions.showModal('CLEAR_YOUR_COUPON', {
                            betData,
                        });
                    }
                } else {
                    NotificationManager.error(
                        <Text
                            fontSize={16}
                            margin={'0'}
                            padding={'0'}
                            bold
                            color={'#fff'}
                        >
                            Ryd din kupon først.
                            <br /> Byg væddemål kan ikke kombineres med andre
                            spil.
                        </Text>
                    );
                }
            } else {
                if (
                    (this.props.isCustomBet &&
                        this.props.betslip.customBetEventId ===
                            this.props.eventObj?.data?.eventId) ||
                    (this.props.isCustomBet &&
                        this.props.betslip.customBetEventId === null)
                ) {
                    this.props.betslipActions.addCustomBetMarket(
                        market.marketId,
                        item.betNr,
                        item.odds,
                        isLive,
                        this.props.betslip.hasMarkets,
                        this.props.isCustomBet
                    );
                } else {
                    this.props.uiActions.notification(
                        UI_ERROR_MESSAGE,
                        getErrorByCode('BAD_COMBINATION')
                    );
                }
            }
        } else {
            if (this.props.betslip.betList.length < 15) {
                if (
                    this.props.betslip.betList.filter(
                        (item) => item.eventId === this.state.event.data.eventId
                    ).length === 0
                ) {
                    this.props.terminalBetslipActions.addMarket(
                        this.props.betslip,
                        market.eventId,
                        this.state.event.data.eventName,
                        market.marketId,
                        item.betNr,
                        0,
                        item.odds,
                        item.bet,
                        market.marketName,
                        this.state.event.data.live,
                        this.state.event
                    );
                } else {
                    this.props.uiActions.notification(
                        UI_ERROR_MESSAGE,
                        getErrorByCode('BAD_COMBINATION')
                    );
                }
            } else {
                this.props.uiActions.betslipLimit();
            }
        }
    }

    onClickRemoveHandler(e) {
        const marketId = this.props.market.marketId;
        if (this.props.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!isTerminal()) {
            if (this.props.isCustomBet) {
                this.props.betslipActions.clearSingleCustomBetMarket(
                    this.props.marketId,
                    this.props.item.betNr
                );
            } else {
                if (this.props.betslip.betList.length > 1) {
                    this.props.betslipActions.clearSystemMarket(
                        this.props.market.eventId,
                        marketId
                    );
                } else {
                    this.props.betslipActions.clearSingleMarket(
                        this.props.market.eventId,
                        marketId
                    );
                }
            }
        } else {
            this.props.terminalBetslipActions.removeMarket(marketId);
        }
    }

    isMarketDisabled() {
        return this.props.isCustomBet
            ? this.props.market.conflict ||
                  this.props.market.status !== MARKET_STATUS.ACTIVE
            : this.props.market.status !== MARKET_STATUS.ACTIVE;
    }

    isEventDisabled() {
        return this.props.isCustomBet
            ? this.props.item.conflict ||
                  (!this.state.event.pending &&
                      this.state.event.data &&
                      this.state.event.data.status !== EVENT_STATUS.IN_PROGRESS)
            : !this.state.event.pending &&
                  this.state.event.data &&
                  this.state.event.data.status !== EVENT_STATUS.IN_PROGRESS;
    }

    getOdds(defaultOdds, updatedOdds = null) {
        if (updatedOdds !== null) {
            return updatedOdds.toFixed(2);
        } else {
            return defaultOdds.toFixed(2);
        }
    }

    getActiveButtons = (item) => {
        let betType =
            this.props.market.marketTypeGroupName === 'Byg væddemål'
                ? 'CUSTOM_BET'
                : 'REGULAR_BET';
        let currentItem = `${betType}_${this.props.market.marketId}_${
            item.betNr
        }_${this.props.market.marketName.replace(/\s/g, '')}`;

        return this.props.betslip.setMarketsNew.includes(currentItem);
    };

    render() {
        if (this.state.event) {
            const item = this.props.item;
            let leftPart = item.competitor || item.bet;
            leftPart = leftPart.charAt(0).toUpperCase() + leftPart.slice(1);

            const isOrange = isActiveBetButton(
                item,
                this.props.market,
                this.props.betslip.setMarketsNew
            );

            const isEventOrMarketDisabled =
                this.isEventDisabled() || this.isMarketDisabled();

            if (item.odds > 1) {
                const changedMarkets = this.state.event.changedMarkets;

                const betIndicatorType =
                    changedMarkets &&
                    changedMarkets[
                        this.props.market.marketId + '-' + item.betNr
                    ] &&
                    changedMarkets[
                        this.props.market.marketId + '-' + item.betNr
                    ].type
                        ? changedMarkets[
                              this.props.market.marketId + '-' + item.betNr
                          ].type
                        : null;

                const indicator = betIndicatorType ? (
                    <OddsIndicator indicator={betIndicatorType}>
                        <i
                            className={
                                'fa fa-caret-up' +
                                (betIndicatorType === 'minus'
                                    ? ' fa-rotate-180'
                                    : '')
                            }
                            aria-hidden="true"
                        />
                    </OddsIndicator>
                ) : null;

                let updatedOdds = null;
                if (this.props.shouldUpdateOdds) {
                    updatedOdds =
                        changedMarkets &&
                        changedMarkets[
                            this.props.market.marketId + '-' + item.betNr
                        ] &&
                        changedMarkets[
                            this.props.market.marketId + '-' + item.betNr
                        ].odds;
                }

                const getButtonText = () => {
                    if (this.props.betTextOnly && !isEventOrMarketDisabled) {
                        return (
                            <OddsButtonWrapper
                                title={this.props.item.bet}
                                isOnlyOdds={this.props.isOnlyOdds}
                            >
                                <p>{this.props.item.bet}</p>

                                <OddsText
                                    oddsYellow
                                    active={isOrange}
                                    disabled={isEventOrMarketDisabled}
                                >
                                    {this.getOdds(item.odds, updatedOdds)}
                                    {indicator}
                                </OddsText>
                            </OddsButtonWrapper>
                        );
                    } else if (
                        !this.props.isOnlyOdds &&
                        !isEventOrMarketDisabled
                    ) {
                        return (
                            <OddsButtonWrapper
                                title={this.props.label}
                                isOnlyOdds={this.props.isOnlyOdds}
                            >
                                {detectMobile() ? (
                                    <p>{this.props.label || leftPart}</p>
                                ) : (
                                    <p>{this.props.label || leftPart}</p>
                                )}

                                <OddsText
                                    oddsYellow
                                    active={isOrange}
                                    disabled={isEventOrMarketDisabled}
                                >
                                    {this.getOdds(item.odds, updatedOdds)}
                                    {indicator}
                                </OddsText>
                            </OddsButtonWrapper>
                        );
                    } else if (!isEventOrMarketDisabled) {
                        return (
                            <OddsButtonWrapper
                                isOnlyOdds={this.props.isOnlyOdds}
                            >
                                <OddsText
                                    oddsYellow
                                    active={isOrange}
                                    disabled={isEventOrMarketDisabled}
                                >
                                    {this.getOdds(item.odds, updatedOdds)}
                                </OddsText>
                            </OddsButtonWrapper>
                        );
                    } else {
                        return (
                            <OddsButtonWrapper isOnlyOdds={true}>
                                {this.getOdds(item.odds, updatedOdds)}
                            </OddsButtonWrapper>
                        );
                    }
                };

                return (
                    <Button
                        mobile={[
                            'margin: 5px 3px;',
                            'font-size: 12px;',
                            'max-height: 45px;',
                            'padding: 5px;',
                        ]}
                        position="relative"
                        textAlign="left"
                        maxHeight="45px"
                        fontSize="13px"
                        width={this.props.isFullWidthButtons ? '100%' : '97%'}
                        margin="10px 5px"
                        padding={
                            isEventOrMarketDisabled ? '20px 10px' : '20px 5px'
                        }
                        active={isOrange}
                        disabled={isEventOrMarketDisabled}
                        onClick={
                            !isEventOrMarketDisabled
                                ? !isOrange
                                    ? this.onClickHandler.bind(this)
                                    : this.onClickRemoveHandler.bind(this)
                                : null
                        }
                    >
                        {getButtonText()}
                    </Button>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return { eventObj: state.eventObject, betslip: state.betslip };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
        betslipActions: bindActionCreators(BetslipActions, dispatch),
        terminalBetslipActions: bindActionCreators(
            TerminalBetslipActions,
            dispatch
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewOddsButton);
